import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DataTable from 'components/Table/DataTable';
import { listUrlSettings } from 'graphql/queries';
import UrlSettingsEditButton from 'forms/UrlSettingsForm/UrlSettingsEditButton';
import { urlModes } from '@silvergatedelivery/constants';
import { getClientIdSchema } from 'forms/schemas';

export default function UrlSettingsTable({ title, description, ...props }) {
  const [clientIdOptions, setClientIdOptions] = useState();

  const columns = [
    {
      name: 'id',
      label: '編號',
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'hostname',
      label: '網域',
      options: {
        display: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'mode',
      label: '模式',
      options: {
        display: true,
        filter: true,
        sort: true,
        customBodyRender: (v) => urlModes.find(({ value }) => value === v)?.label ?? '',
      },
    },
    {
      name: 'clientId',
      label: '指定機構',
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender(clientId) {
          if (!clientIdOptions) return '';

          const index = clientIdOptions.enum.findIndex((id) => id === clientId);
          if (index === -1) return '';

          return clientIdOptions.enumNames[index];
        },
      },
    },
    {
      name: 'name',
      label: '機構名稱',
      options: {
        display: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'shortName',
      label: '機構簡稱',
      options: {
        display: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'isOfficialVersion',
      label: '正式版本',
      type: 'checkbox',
      options: {
        display: true,
        filter: true,
        sort: true,
        filterOptions: {
          renderValue: (v) => v ? '是' : '否',
        },
        customFilterListOptions: {
          render: (v) => v ? '是正式版本' : '非正式版本',
        },
      },
    },
    {
      name: 'lineLoginEnabled',
      label: 'LINE登入',
      type: 'checkbox',
      options: {
        display: true,
        filter: true,
        sort: true,
        filterOptions: {
          renderValue: (v) => v ? '是' : '否',
        },
        customFilterListOptions: {
          render: (v) => v ? '支援Line登入' : '不支援Line登入',
        },
      },
    },
    {
      name: 'liffId',
      label: 'LIFF ID',
      options: {
        display: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'createdBy',
      label: '創立者',
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'updatedBy',
      label: '更新者',
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'createdAt',
      label: '創立於',
      type: 'datetime',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'updatedAt',
      label: '更新於',
      type: 'datetime',
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
  ];

  useEffect(() => {
    const fetchClientIdOptions = async () => {
      const clientIdOptions = await getClientIdSchema(null, null, false, true, true);
      setClientIdOptions(clientIdOptions);
    };

    fetchClientIdOptions();
  }, []);

  return (
    <DataTable
      title={title || '網址設定'}
      description={description}
      columns={columns}
      indexes={[
        {
          name: 'scan',
          label: '掃描全部資料',
          fields: [
            {
              label: '網域',
              key: 'hostname',
              comparisonOperator: 'contains',
            },
          ],
          operation: listUrlSettings,
        },
      ]}
      editButton={UrlSettingsEditButton}
      {...props}
    />
  );
}

UrlSettingsTable.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
